import React from "react"
import Select from "react-select"
import { installedApps } from "../../pages/terminals/components/terminalApplicationData"

const styles = {
  container: (base) => ({ ...base, width: "100%", minWidth: 0 }),
  control: (base) => ({ ...base, minHeight: 58, padding: 6 }),
  singleValue: (base) => ({ ...base, whiteSpace: "normal", overflowWrap: "anywhere" }),
  option: (base) => ({ ...base, whiteSpace: "normal", overflowWrap: "anywhere", padding: 12 }),
  menuPortal: (base) => ({ ...base, zIndex: 1500 }),
}

// Package names identify installed apps even when no catalog applicationId is reported.
export const installedPackageName = (app) => String(app?.appId ?? "").trim()

const InstalledApplicationsDropdown = ({ terminal, value, onChange, isDisabled, error, autoFocus, menuPortalTarget }) => {
  const applications = installedApps(terminal)
  const options = (applications || []).filter((app) => installedPackageName(app) !== "default")

  return (
    <div style={{ width: "100%", minWidth: 0 }}>
      <p style={{ fontSize: 12, margin: "0 0 6px", lineHeight: "18px", fontWeight: 500 }}>Application</p>
      <Select
        key={terminal?.serialNo}
        aria-label="Installed application"
        aria-invalid={error || undefined}
        autoFocus={autoFocus}
        value={value ? options.find((app) => installedPackageName(app) === value) || null : null}
        onChange={onChange}
        options={options}
        getOptionValue={installedPackageName}
        getOptionLabel={(app) => `${app.appName || installedPackageName(app)} (${installedPackageName(app)})`}
        formatOptionLabel={(app) => (
          <div style={{ lineHeight: 1.45 }}>
            <div style={{ fontSize: 13, fontWeight: 500 }}>{app.appName || installedPackageName(app) || "Unknown application"}</div>
            {/* <div style={{ fontSize: 12 }}>{installedPackageName(app) || "Package name unavailable"}</div> */}
          </div>
        )}
        isOptionDisabled={(app) => !installedPackageName(app) || /\s|[^\x21-\x7E]/.test(installedPackageName(app))}
        noOptionsMessage={({ inputValue }) => inputValue ? "No matching installed applications" : applications == null ? "Installed applications not reported" : "No installed applications reported"}
        placeholder="Select installed application"
        isClearable
        isDisabled={isDisabled}
        menuPortalTarget={menuPortalTarget}
        menuPosition={menuPortalTarget ? "fixed" : "absolute"}
        styles={styles}
      />
    </div>
  )
}

export default InstalledApplicationsDropdown
